import { c as _c } from "react/compiler-runtime";
import React, { useState } from 'react';
import classNames from 'classnames';
import SuspenseWithLoader from 'components/consumer/SuspenseWithLoader';
import usePDPInfoSections from '../PDPInfoSections/usePDPInfoSections';

// Mobile counterpart to PDPInfoTabs: four tab labels do not fit on a phone, so
// the same sections stack as expandable rows. Panels stay mounted while closed
// so a section that loads its own media is not torn down on every toggle.
const PDPInfoAccordionInner = () => {
  const $ = _c(8);
  const items = usePDPInfoSections();
  const [openId, setOpenId] = useState(null);
  if (!items.length) {
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t0 = <div className="PDPInfoAccordion__filler" />;
      $[0] = t0;
    } else {
      t0 = $[0];
    }
    return t0;
  }
  let t0;
  if ($[1] !== items || $[2] !== openId) {
    let t1;
    if ($[4] !== openId) {
      t1 = t2 => {
        const {
          id,
          label,
          content
        } = t2;
        const isOpen = openId === id;
        return <div key={id} className="border-t border-gray-light7"><button type="button" aria-expanded={isOpen} aria-controls={`${id}-panel`} className="bg-transparent border-0 cursor-pointer flex items-center justify-between py-4 px-0 text-left w-full" onClick={() => setOpenId(isOpen ? null : id)}><span className="text-base font-bold text-gray">{label}</span><span className="text-2xl text-gray-light1">{isOpen ? String.fromCharCode(8722) : "+"}</span></button><div id={`${id}-panel`} className={classNames("pb-6", {
            hidden: !isOpen
          })}>{content}</div></div>;
      };
      $[4] = openId;
      $[5] = t1;
    } else {
      t1 = $[5];
    }
    t0 = items.map(t1);
    $[1] = items;
    $[2] = openId;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  let t1;
  if ($[6] !== t0) {
    t1 = <div className="mt-8" data-xc="PDPInfoAccordion">{t0}</div>;
    $[6] = t0;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  return t1;
};
const PDPInfoAccordion = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <SuspenseWithLoader><PDPInfoAccordionInner /></SuspenseWithLoader>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default PDPInfoAccordion;